import { FieldBaseClasses } from '@/components/ui/fieldStyles';
import { cn } from '@/lib/utils';

export function Textarea({ className, rows = 6, ...props }) {
  return (
    <textarea
      rows={rows}
      data-slot="textarea"
      className={cn(FieldBaseClasses, 'min-h-36 resize-y px-4 py-3 leading-relaxed', className)}
      {...props}
    />
  );
}